export default __webpack_public_path__ + "static/logo-409406c4c01c971b4781ee173cbe658d.png";